<template>
  <div class="about-page">
    <!-- <div :class="isPublicRoute() == true ? 'theme-card adjustment':'theme-card'"> -->
      <div class="page-hero">
        <div class="page-hero-context">
          <div class="page-hero-text">About Us</div>
          <div class="page-hero-subtext">Who we are and what we've got for you.</div>
        </div>
      </div>

      <div class="full-intro">
        <div class="info-header">Job Search & Recruitment Platform</div>
        <div class="intro-context">
        Vocation is a Job Search and Recruitment Platform by Vocation Software Ltd with the goal of connecting Job Seekers and Organizations on Malawi's thriving job market.

        Vocation aims to be the go-to platform for all things recruitment and job search; with tailor-made tools developed with job seekers and recruiters in mind. Our goal is to enhance search and recruitment workflows.
        </div>
      </div>

    <div class="info-cards">

      <div class="info-card">
         <div class="content-image-box content-image-one">
        </div>
        <div class="info-content">
          <div class="info-header sub-header">Tools For Enhanced Job Search Experience</div>
          <div class="info-body">We provide tools and features that enable job seekers browse and fine-tune search results, keep track of their applications history, save job openings for future applications and as well as send their job applications directly from the platform.</div>
        </div>     
      </div>

      <div class="info-card">
          <div class="content-image-box content-image-two">
        </div>
        <div class="info-content">
          <div class="info-header sub-header">Recruiters' Enterprise Tools & Features</div>
          <div class="info-body">Our special Vocation &trade; Enterprise offering gives recruiters and various institutions enterprise-grade tools to publish vacancies, recieve and keep track of applications from aspiring candidates, offers candidate preview features as well as keep track of recruitment cycles of candidates.</div>
        </div>  
       
      </div>

    </div>
    <div class="video-section">
      <div class="video-description">
        <div class="info-header sub-header">Introduction to Vocation</div>
        <div class="info-body">
          Watch this video by <a href="https://linkedin.com/in/helixwchipofya" style="color:var(--page-header);text-decoration:none;" target="blank">Helix W. Chipofya (Founder & Chief Exective Officer)</a> as he introduces and walks through the main features that Vocation has got to offer.
        </div>
      </div>
      <div class="video-container">
        <div class="main-vid-container">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/wOz-BcjEv14?si=hxo4rZGrhPv0KU9r" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <ContactInformation/>

  </div>
</template>
<script>
  import PageHeader from '@/components/Utility/PageHeader.vue';
  import ContactInformation from '@/components/ContactInformation.vue';
  export default{
    components:{
      PageHeader, ContactInformation
    },
    mounted(){
       window.scrollTo({top: 0,behavior: 'smooth'});
    },
     methods:{
        isPublicRoute(){
            return this.$route.name == 'about' ? true : false
        }
    }
  }
</script>
<style scoped>


  .page-hero-subtext{
     color:white;
  }

    .page-hero-context{
      justify-self: center;
      align-self: center;
      margin-top: 3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .page-hero-text{
      
      color:white;
      font-size:3rem;
      font-family: var(--job-title-font);
    }
    .page-hero{
      background:url('../assets/images/about.jpg') fixed, rgb(230, 24, 24);
      background-blend-mode:darken;
      background-size: cover;
      background-repeat: no-repeat;
      background-position:0% 80%;
      min-height:20rem;
      display: grid;
      margin-bottom:2rem;
    }
    .about-page{
      background-color: var(--info-page-background);
      margin:-2rem 0rem;
      display: grid;
    }
    .info-header{
      font-family: var(--page-header-font);
    }

    .full-intro{
      margin-left:1rem;
      margin-right:1rem;
      margin-bottom:2rem;
      font-size:1rem;
    }

    
    .info-body{
      font-size:1rem;
      font-family: var(--body-font);
    }

   

    .info-header{
      font-size:2rem;
      margin-bottom:0.5rem;
      color:var(--page-header);
      line-height:2.6rem;
    }

    .sub-header{
      font-size:1.5rem;
      margin-bottom:0.5rem;
      color:var(--page-header);
      line-height:2rem;
    }


    .content-image{
      /* display: grid; */
      height:20rem;
      
    }
    
    .content-image-box{
      width:8.5rem;
      height:15rem;
      
      
      
      
    }
    
    .info-card{
      display: flex;
      column-gap: 2rem;
      margin-bottom:2rem;
    }

  

    .info-content{
      flex:1;
    }

    .adjustment{
        margin-top: 3rem!important;
   }

   .theme-card{
    border-radius:16px!important;
    padding:2rem;
    background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background);
   }

   .public{
      margin-top: 1rem!important;
   }

   .img{
      transform: translateY(-4rem);
    }

    .img-two{
      transform: translateY(-3rem);
    }

    .content-image-one{
      background: url('../assets/images/about4.jpg');
      background-size:cover;
      border-top-left-radius:20px;
      border-bottom-left-radius:20px;
      background-position:25% 0%;
      background-repeat: no-repeat;
      border-right:4px solid var(--page-header);
    }

     .content-image-two{
      background: url('../assets/images/about3.jpg');
      background-size:cover;
      border-top-left-radius:20px;
      border-bottom-left-radius:20px;
      background-repeat: no-repeat;
       border-right:4px solid var(--page-header);
    }

    .info-cards{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* grid-template-rows: repeat(2, 1fr); */
      column-gap:1.5rem;
      margin-left:1rem;
      margin-right:1rem;
      /* margin-bottom:2rem; */
    }

  .video-section{
    display: flex;
    column-gap:1.5rem;
      margin-left:1rem;
      margin-right:1rem;
  }
  
  .video-description, .video-container{
    flex: 1;
  }

  .main-vid-container{
    width:35rem;
    height:20rem;
  }


   @media(max-width: 768px){

  .main-vid-container{
    width:19rem;
    height:11rem;
  }

     .video-section{
      flex-direction: column;
      row-gap: 2rem;
     }

     .video-container{
      margin-bottom:2rem;
        display: flex;
        justify-content: center;
     }


     .adjustment{
        margin-top: 2rem!important;
   }

   .theme-card{
    
    padding:1rem;
    background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background);
   }

   .info-header{
    font-size:1.2rem;
    line-height:1.6rem;
   }

   .info-body{
    font-size:0.9rem;
   }

   .content-image-box{
      /* width:30rem; */
      height:none;
      width:3rem;

    }

    .img{
      transform: translate(-15rem,-4rem);
    }

    .img-two{
      transform: translateX(-12rem);
    }

    .img-three{
      transform: translateX(-3rem);
    }

    .info-card{
      display: flex;
      column-gap: 1rem;
      margin-bottom:2rem;
    }

    
    .info-content{
      flex:1;
    }

    .page-hero{
      background:url('../assets/images/about.jpg'), rgb(230, 24, 24);
      background-blend-mode:darken;
      background-size: cover;
      background-repeat: no-repeat;
      background-position:20% 50%;
      min-height:17rem;
      display: grid;
       margin-bottom:1rem;
    }

    .page-hero-text{
      font-size:1.8rem;
    }

    .page-hero-subtext{
      font-size:0.7rem;
      margin-top:-0.4rem;
    }

    .page-hero-context{
      margin-top:3.6rem;
    }

    .full-intro{
      margin-left:0.5rem;
      margin-right:0.5rem;
      margin-bottom:1.4rem;
    }

    .intro-context{
      font-size:0.9rem;
    }

     .info-cards{
      display: flex;
      flex-direction: column;
      /* grid-template-rows: repeat(2, auto); */
      /* grid-template-rows: repeat(2, 1fr); */
      /* column-gap:1.5rem;
      margin-left:1rem;
      margin-right:1rem;
      margin-bottom:2rem; */
    }

    .info-card:nth-child(2){
      flex-direction: row-reverse ;
    }

    
     .content-image-two{
      background: url('../assets/images/about3.jpg');
      background-size:cover;
      border-top-left-radius:0px;
      border-bottom-left-radius:0px;
      border-top-right-radius:12px;
      border-bottom-right-radius:12px;
      background-repeat: no-repeat;
      border-right:0px;
      border-left:4px solid var(--page-header);
      background-position: 15% 0%;
    }

    .content-image-one{
      border-top-left-radius:12px;
      border-bottom-left-radius:12px;
      background-position: 37.4% 0%;
    }

    .sub-header{
      line-height:1.6rem;
    }
    

   }
</style>
